<template>
    <li class="relative">
        <button
            @click="copyLink"
            class="
                bg-gray-120
                dark:bg-gray-700
                border 
                border-keyline-primary
                hover:border-keyline-primary-invert
                flex 
                gap-3 
                group 
                items-center 
                leading-none 
                max-w-full 
                relative 
                rounded 
                text-left 
                w-full 
                p-4
            "
        >
            <BaseSvg name="Link" aria-hidden="true" class="fill-v2-gray-70 size-5 dark:fill-v2-gray-90"/>
            <span class="leading-none text-sm text-v2-gray-20 dark:text-v2-gray-130 dark:group-hover:text-v2-white">Copy share link</span>
        </button>
        <!-- When the button is selected, add class `confirmation-run` -->
        <span ref="copyButton" class="confirmation-ready" aria-hidden="true">
            <BaseSvg name="Check" aria-hidden="true" class="size-4"/>
            Copied
        </span>
    </li>
</template>

<script setup>
import {ref} from "vue";

const copyButton = ref();
function copyLink() {
    navigator.clipboard.writeText(window.location.href);
    copyButton.value?.classList.add('confirmation-run');
    setTimeout(() => {
        copyButton.value?.classList.remove('confirmation-run');
    }, 3000);
}
</script>
